import pluralize from 'pluralize';

const Utils = {
  capitalize: (arg, all) => {
    if (!arg) {
      return arg;
    }

    if (all) {
      return arg
        .split(' ')
        .map((e) => e.capitalize())
        .join(' ');
    }

    return arg.charAt(0).toUpperCase() + arg.slice(1);
  },

  indent: (text, spaces) => {
    if (!text) {
      text = '';
    }
    if (!spaces) spaces = 0;
    text = text.replace('\r\n', '\n').replace('\r', '\n');
    const lines = text.split(/\n/).map((line) => {
      if (!line || line.trim().length <= 0) {
        return null;
      }
      return Utils.whitespaces(spaces) + line;
    });
    return lines.join('\n');
  },

  whitespaces: (count) => {
    let line = '';
    for (let i = 0; i < count; i++) {
      line += ' ';
    }
    return line;
  },

  camelToHyphen: (text) => {
    if (!text) {
      return text;
    }
    return text.replace(/([A-Z])/g, '-$1').toLowerCase();
  },

  camelToUnderscore: (text) => {
    if (!text) {
      return text;
    }

    return text.replace(/([A-Z])/g, '_$1').toLowerCase();
  },

  hyphenToCamel: (text) => {
    if (!text) return text;
    return text.replace(/-([a-zA-Z])/g, (g) =>
      g[1].toUpperCase(),
    );
  },

  underscoreToCamel: (text) => {
    if (!text) return text;
    return text.replace(/_([a-zA-Z])/g, (g) =>
      g[1].toUpperCase(),
    );
  },

  hyphenToUnderscore: (text) => {
    if (!text) return text;
    return text.split('-').join('_');
  },

  underscoreToHyphen: (text) => {
    if (!text) return text;
    return text.split('_').join('-');
  },

  replaceAll(text, search, replace) {
    if (!text) return text;
    return text.split(search).join(replace);
  },

  camelAndCapitalize: (text) => {
    if (!text) return text;
    return Utils.capitalize(
      Utils.hyphenToCamel(Utils.underscoreToCamel(text)),
    );
  },

  uncapitalize: (text) => {
    if (!text || typeof text !== 'string') {
      return '';
    }
    return text.charAt(0).toLowerCase() + text.substr(1);
  },
};

export default class NameLabelNormalizer {
  static createPlural(arg) {
    if (!arg) {
      return '';
    }

    return pluralize(arg) || '';
  }

  static createLabel(arg) {
    if (!arg) {
      return '';
    }

    return Utils.capitalize(this.createObject(arg)) || '';
  }

  static createLabelPlural(arg) {
    return pluralize(this.createLabel(arg)) || '';
  }

  static createObject(arg) {
    if (!arg) return arg;

    if (arg === arg.toUpperCase()) {
      arg = arg.toLowerCase();
    }

    arg = Utils.underscoreToHyphen(arg);
    arg = Utils.hyphenToCamel(arg);
    arg = Utils.uncapitalize(arg);
    arg = Utils.replaceAll(arg, '-', '');

    return arg || '';
  }
}
